require('./ProgramEntryPoint.scss');

const b = require('app/www/libs/b')('program-entry-point');

const React = require('react');
const PropTypes = require('prop-types');

const Metrika = require('app/www/libs/client/metrika');

const Image = require('app/www/components/blocks/Image/Image');
const Link = require('app/www/components/blocks/Link/Link');

class ProgramEntryPoint extends React.PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            hidden: false,
        };

        this._onClickClose = this._onClickClose.bind(this);
    }

    componentDidMount() {
        this._sendMetrika('show');
    }

    render() {
        const {
            campaign,
            url,
            ldpi,
            hdpi,
            text,
        } = this.props;

        const {hidden} = this.state;

        const linkProps = {
            url,
            onClick: () => this._sendMetrika('click'),
        };

        const imageProps = {
            sizes: {
                0: {src: ldpi},
                1: {src: hdpi},
            },
            alt: text,
        };

        return (
            <div className={b({[campaign]: true, hidden})}>
                <i className={b('close')} onClick={this._onClickClose} />
                <Link className={b('link')} {...linkProps}>
                    <Image className={b('image')} {...imageProps} />
                </Link>
            </div>
        );
    }

    /**
     * Отправляем данные в метрику
     * @param {String} action show|click
     * @private
     */
    _sendMetrika(action) {
        const {campaign} = this.props;

        Metrika.trackParams('ENTRY_POINT', {
            control: 'teaser',
            campaign,
            action,
        });
    }

    /**
     * @private
     */
    _onClickClose() {
        this.setState({
            hidden: true,
        });
    }

}

ProgramEntryPoint.propTypes = {
    campaign: PropTypes.string.isRequired,
    url: PropTypes.string,
    ldpi: PropTypes.string.isRequired,
    hdpi: PropTypes.string.isRequired,
    text: PropTypes.string,
};

module.exports = ProgramEntryPoint;
